import { render, staticRenderFns } from "./SustLinks.vue?vue&type=template&id=d5a6aff0&scoped=true"
import script from "./SustLinks.vue?vue&type=script&lang=js"
export * from "./SustLinks.vue?vue&type=script&lang=js"
import style0 from "./SustLinks.vue?vue&type=style&index=0&id=d5a6aff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a6aff0",
  null
  
)

export default component.exports